module.exports = __webpack_public_path__ + "static/media/Sunny soffa 3-sits xl tyg rober detalj 2023 3.5b258108.jpg";